import React from "react";

const Loading = props => (
    <div>
        Loading ...
    </div>
);

export default Loading;
